import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../config/constants";
// Components
import Loader from "../loader";
import Axios from "../../config/axios";
import PatientNavigation from "../patientNavigation";
import Title from "../title";
import ReferenceDates from "./referenceDates";
import ArmEnergyPerDate from "./armEnergyPerDatePlot";
import ArmEnergyPerHour from "./armEnergyPerHourPlot";

const WearReferenceDates = () => {
  const [isLoadingArmEnergyDates, setIsLoadingArmEnergyDates] = useState(true);
  const [isLoadingReferenceDates, setIsLoadingReferenceDates] = useState(true);
  const [referenceDates, setReferenceDates] = useState([]);
  const [armEnergyDates, setArmEnergyDates] = useState([]);
  const { patientId } = useParams();

  // Fetch reference dates
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/arm-reference-date/get/${patientId}`)
      .then(({ data }) => {
        setReferenceDates(data);
        setIsLoadingReferenceDates(false);
      })
      .catch((error) => {
        console.log("Endpoint to get reference dates: ", error);
      });
  }, [patientId]);

  // Fetch arm energy
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/arm-reference-date/get-energy/${patientId}`)
      .then(({ data }) => {
        setArmEnergyDates(data);
        setIsLoadingArmEnergyDates(false);
      })
      .catch((error) => {
        console.log("Endpoint to get arm energy: ", error);
      });
  }, [patientId]);

  const checkingReferenceDates = () => {
    if (armEnergyDates.length) {
      return (
        <>
          <ArmEnergyPerDate armEnergyDates={armEnergyDates} />
          <ArmEnergyPerHour referenceDates={referenceDates} />
        </>
      );
    }
  };

  const isLoading = isLoadingArmEnergyDates || isLoadingReferenceDates;

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <PatientNavigation patientId={patientId} section="wear" />
          <Title title={`RGS WEAR`} marginBottom="10px" />
          <ReferenceDates referenceDates={referenceDates} />
          {checkingReferenceDates()}
        </>
      )}
    </>
  );
};

export default WearReferenceDates;
